<template>
  <div class="aali_tm_all_wrap" data-magic-cursor="show">
    <!-- 浮動按鈕區塊 -->
    <!-- <div class="floating-buttons">
      <a href="#home" class="floating-btn" data-text="ome">H</a>
      <a href="#about" class="floating-btn" data-text="bout">A</a>
      <a href="#skills" class="floating-btn" data-text="kills">S</a>
      <a href="#portfolio" class="floating-btn" data-text="ortfolio">P</a>
      <a href="#service" class="floating-btn" data-text="ield">F</a>
      <a href="#resume" class="floating-btn" data-text="esume">R</a>
      <a href="#life" class="floating-btn" data-text="ife">L</a>
    </div> -->
    <MobileMenu />
    <Header />
    <Home />
    <About />
    <Skills />
    <Portfolio />
    <Service />
    <Resume />
    <!-- <Testimonial /> -->
    <Counter />
    <Contact />
    <Footer />
    <!-- Curosr -->
    <Mouse />
  </div>
</template>

<script>
import About from "../components/About.vue";
import Contact from '../components/Contact.vue';
import Counter from "../components/Counter.vue";
import Home from "../components/Home.vue";
import Footer from "../components/layouts/Footer.vue";
import Header from "../components/layouts/Header.vue";
import MobileMenu from "../components/layouts/MobileMenu.vue";
import Mouse from "../components/layouts/Mouse.vue";
import Portfolio from "../components/Portfolio.vue";
import Resume from "../components/Resume.vue";
import Service from "../components/Service.vue";
import Skills from "../components/Skills.vue";
// import Testimonial from "../components/Testimonial.vue";
export default {
  name: "Index",
  components: {
    Header,
    Home,
    About,
    Skills,
    Portfolio,
    Service,
    Resume,
    Mouse,
    Counter,
    Footer,
    MobileMenu,
    Contact,
    // Testimonial,
  },
};
</script>
